import React, { useEffect, useRef, useState } from 'react';
import {
  Container,
  TextField,
  Button,
  Box,
  Typography,
  Paper,
  IconButton,
  Select,
  MenuItem,
  InputLabel,
  useMediaQuery,
  useTheme,
  CircularProgress,
  Backdrop,
} from '@mui/material';
import {
  MdArrowBackIos,
  MdCameraAlt,
  MdFlipCameraIos,
  MdHome,
  MdOutlineFileUpload,
} from 'react-icons/md';
import { FaImage } from 'react-icons/fa6';
import {
  filter,
  find,
  findIndex,
  includes,
  isEmpty,
  last,
  map,
  omit,
  partition,
  split,
  startsWith,
  sum,
  trim,
  uniqBy,
} from 'lodash';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaCheckCircle } from 'react-icons/fa';
import Webcam from 'react-webcam';
import fileUploadService from '../../services/fileUploadService';
import itemDeliveryService from '../../services/itemDeliveryService';
import { UserHeader } from '../../components/AdminHeader';
import Footer from '../../components/Footer';
import { ImageModal } from '../supervisor/SupervisorForm';
import {
  base64ToFile,
  dataURLtoFile,
  getAddressFromCoords,
  isBase64Image,
  resizeImage,
} from '../../common';
import { CgSoftwareUpload } from 'react-icons/cg';
import { IoCamera } from 'react-icons/io5';
import { WebcamPopup } from './OutwardItem';

const PWAPickupForm = () => {
  const webcamRef = useRef();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const station = localStorage?.getItem('stations')
    ? JSON.parse(localStorage?.getItem('stations'))
    : [];
  const products = localStorage?.getItem('products')
    ? JSON.parse(localStorage?.getItem('products'))
    : [];
  const [selectedFile, setSelectedFile] = useState(null);
  const [file, setFile] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [itemTypes, setItemTypes] = useState([]);
  const [items, setItems] = useState([]);
  const [itemDeliveries, setItemDeliveries] = useState([]);
  const [allocations, setAllocations] = useState([]);
  const [imageUploading, setImageLoading] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [balanceError, setBalanceError] = useState(false); // Track balance error
  const [capturePhoto, setCapturePhoto] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [facingMode, setFacingMode] = useState('environment'); // Default to front camera
  const [openModal, setOpenModal] = useState(false); // Modal visibility state
  const [selectedImage, setSelectedImage] = useState(null); // Store the item to be edited
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [loading, setLoading] = useState(false);
  const [localPhotos, setLocalPhotos] = useState({});

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedImage(null);
  };

  const toggleCamera = () => {
    setFacingMode((prevMode) => (prevMode === 'user' ? 'environment' : 'user'));
  };

  const fetchItemDeliveries = async () => {
    try {
      setLoading(true); // start loading
      const response = await itemDeliveryService.getItemDeliveriesDetails();

      const responseData = filter(response.data, (data) =>
        includes(products, data?.item_name)
      );

      if (selectedDepartment) {
        setItemDeliveries(
          filter(
            responseData,
            (data) =>
              data?.station === selectedDepartment &&
              data?.event_id === parseInt(localStorage?.getItem('event_id')) &&
              data?.delivered_qty !== 0
          )
        );
      } else {
        const array = filter(
          responseData,
          (data) =>
            includes(station, data?.station) &&
            data?.event_id === parseInt(localStorage?.getItem('event_id'))
        );
        setDepartments(uniqBy(array, 'station'));
      }
    } catch (error) {
      console.error('Error fetching item deliveries:', error);
    } finally {
      setLoading(false); // stop loading
    }
  };

  // const fetchItemDeliveries = async () => {
  //   const response = await itemDeliveryService.getItemDeliveriesDetails();
  //   const responseData = filter(response.data, (data) =>
  //     includes(products, data?.item_name)
  //   );
  //   if (selectedDepartment) {
  //     setItemDeliveries(
  //       filter(
  //         responseData,
  //         (data) =>
  //           data?.station === selectedDepartment &&
  //           data?.event_id === parseInt(localStorage?.getItem('event_id')) &&
  //           data?.delivered_qty !== 0
  //       )
  //     );
  //   } else {
  //     const array = filter(
  //       responseData,
  //       (data) =>
  //         includes(station, data?.station) &&
  //         data?.event_id === parseInt(localStorage?.getItem('event_id'))
  //     );
  //     setDepartments(uniqBy(array, 'station'));
  //   }
  // };

  const handleSubmit = async () => {
    // const data = map(uniqBy(allocations, 'id'), (allocation) =>
    //   omit(allocation, ['timestamp', 'entered_qty', 'delivered_date'])
    // );
    // const photosToAdd = Array.isArray(file) ? file : [file];

    const data = {
      user_id: parseInt(localStorage?.getItem('user_id')),
      updates: map(
        map(uniqBy(allocations, 'id'), (data) => {
          return {
            ...data,
            // photo: data.photo
            //   ? `${data.photo}, ${photosToAdd.join(', ')}`
            //   : photosToAdd.join(', '),
            remarks: 'picked',
            // station: selectedDepartment,
            station_type: data?.station_type,
            user_id: parseInt(localStorage?.getItem('user_id')),
            // latitude: location?.latitude,
            // longitude: location?.longitude,
          };
        }),
        (allocation) =>
          omit(allocation, [
            'timestamp',
            'entered_qty',
            'delivered_date',
            'item_name',
            'station',
          ])
      ),
    };

    try {
      const res = await itemDeliveryService?.updateItemDelivery(
        selectedDepartment,
        data
      );
      if (res?.status === 200) {
        toast?.success('Data submitted successfully');
        setFile(null);
        setFile(null);
        // setSelectedDepartment('');
        setAllocations([]);
        setCapturePhoto(false);
        // setBalanceError(false);
        setItemDeliveries([]);
        fetchItemDeliveries();
        setLocalPhotos({});
        // setItems([]);
      }
    } catch (e) {
      toast.error(e?.response?.data?.message);
    }
  };

  useEffect(() => {
    const handleSuccess = (position) => {
      const { latitude, longitude } = position.coords;
      setLocation({ latitude, longitude });
    };

    const handleError = (error) => {
      console?.error('Geolocation is not supported by this browser.');
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(handleSuccess, handleError);
    } else {
      console?.error('Geolocation is not supported by this browser.');
    }
  }, []);

  useEffect(() => {
    fetchItemDeliveries();
    setAllocations([]);
  }, [selectedDepartment]);

  const handleInputChange = (id, value, item, uploadedPhoto) => {
    const photosToAdd = Array.isArray(uploadedPhoto)
      ? uploadedPhoto
      : [uploadedPhoto];

    const quantity = value
      ? parseInt(value, 10)
      : find(allocations, { id: parseInt(id) })
      ? find(allocations, { id: parseInt(id) })?.picked_qty
      : 0;

    const newAllocation = {
      ...item,
      picked_qty: quantity,
      delivered_qty: 0,
      photo: uploadedPhoto
        ? item?.photo
          ? `${item?.photo}, ${photosToAdd.join(', ')}`
          : photosToAdd.join(', ')
        : '',
    };

    const existingIndex = findIndex(allocations, { id: id });
    if (existingIndex >= 0) {
      const updatedAllocations = [...allocations];
      updatedAllocations[existingIndex] = newAllocation;
      setAllocations(updatedAllocations);
    } else {
      setAllocations([...allocations, newAllocation]);
    }
  };

  console.log('allocations', allocations);

  const getLineColor = (index) => {
    const colors = ['#469289', '#B29939', '#2B5786', '#66933F']; // Color sequence
    return colors[index % 3]; // Cycle through colors based on index
  };

  const handleCapturePhoto = async () => {
    try {
      setImageLoading(true);
      const imageSrc = webcamRef.current.getScreenshot();
      if (!imageSrc) throw new Error('Failed to capture image from webcam.');

      // Get geolocation coordinates
      const coords = await new Promise((resolve, reject) =>
        navigator.geolocation.getCurrentPosition(
          (pos) => resolve(pos.coords),
          (err) => reject(new Error('Unable to get location: ' + err.message))
        )
      );

      // Get address
      const address = await getAddressFromCoords(
        coords.latitude,
        coords.longitude
      );

      const img = new Image();
      img.src = imageSrc;

      img.onload = async () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');

          // Draw original image
          ctx.drawImage(img, 0, 0);

          // Lines to display
          const lines = [
            address,
            `Lat: ${coords.latitude.toFixed(
              5
            )} | Lng: ${coords.longitude.toFixed(5)}`,
            new Date().toLocaleString(),
          ];

          const padding = 10;
          const lineHeight = 18;
          const mapWidth = isMobile ? 140 : 200;
          const textWidth = canvas.width - mapWidth - padding * 3;
          const boxHeight = Math.max(
            lineHeight * lines.length + padding * 2,
            100
          );
          const y = canvas.height - boxHeight;

          // Draw background box
          ctx.fillStyle = 'rgba(0,0,0,0.7)';
          ctx.fillRect(0, y, canvas.width, boxHeight);

          // Load static Google map
          const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${coords.latitude},${coords.longitude}&zoom=14&size=${mapWidth}x${boxHeight}&markers=color:red%7C${coords.latitude},${coords.longitude}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;

          const mapImg = new Image();
          mapImg.crossOrigin = 'Anonymous';
          mapImg.src = staticMapUrl;

          mapImg.onload = () => {
            try {
              const mapBottomPadding = 10;
              ctx.drawImage(
                mapImg,
                padding,
                y,
                mapWidth,
                boxHeight - mapBottomPadding
              );

              // Draw wrapped text
              ctx.fillStyle = 'white';
              ctx.font = isMobile ? '10px Arial' : '16px Arial';
              ctx.textAlign = 'left';
              const textX = mapWidth + padding * 2;
              let textY = y + padding;

              lines.forEach((line) => {
                const words = line.split(' ');
                let lineText = '';
                words.forEach((word) => {
                  const testLine = lineText + word + ' ';
                  const metrics = ctx.measureText(testLine);
                  if (metrics.width > textWidth) {
                    ctx.fillText(lineText, textX, textY);
                    lineText = word + ' ';
                    textY += lineHeight;
                  } else {
                    lineText = testLine;
                  }
                });
                ctx.fillText(lineText, textX, textY);
                textY += lineHeight;
              });

              // Export stamped image
              const stampedDataURL = canvas.toDataURL('image/jpeg');
              const stampedFile = dataURLtoFile(
                stampedDataURL,
                `Pickup_photo_${Date.now()}.jpg`
              );
              handleFileChange(stampedFile);
            } catch (innerErr) {
              console.error('❌ Error while drawing map or text:', innerErr);
              alert('Failed to process image overlay.');
            }
          };

          // Map load error fallback
          mapImg.onerror = (e) => {
            console.warn('⚠️ Map failed to load:', e);

            // Draw only text (no map)
            ctx.fillStyle = 'white';
            ctx.font = isMobile ? '10px Arial' : '16px Arial';
            ctx.textAlign = 'left';
            let textY = y + padding;
            lines.forEach((line) => {
              ctx.fillText(line, padding * 2, textY);
              textY += lineHeight;
            });

            const stampedDataURL = canvas.toDataURL('image/jpeg');
            const stampedFile = dataURLtoFile(
              stampedDataURL,
              `Pickup_photo_${Date.now()}.jpg`
            );
            handleFileChange(stampedFile);
          };
        } catch (processErr) {
          console.error('❌ Error processing image:', processErr);
          alert('Failed to process image. Please try again.');
        }
      };

      img.onerror = () => {
        throw new Error('Failed to load captured image.');
      };
    } catch (err) {
      console.error('❌ Error capturing photo:', err);
      alert(
        err.message ||
          'Unable to capture photo. Please check camera or location permissions.'
      );
      setImageLoading(false);
      setSelectedItem({});
    }
  };

  const handleFileChange = async (input, upload, item) => {
    let file = input;

    if (isBase64Image(input)) {
      file = base64ToFile(input);
    }

    if (file.size > 2 * 1024 * 1024) {
      file = await resizeImage(file);
    }

    const obj = !isEmpty(item) ? item : selectedItem;
    const normalizedName = file.name.replace(/^Pickup_photo_/i, '');

    try {
      setImageLoading(true);
      const res = await fileUploadService?.handleFileUpload(
        new File([file], `Pickup_photo_${normalizedName}`, {
          type: file.type,
        })
      );
      if (res?.status === 200) {
        const filename = startsWith(res?.data?.filename, 'Pickup_photo_')
          ? res?.data?.filename
          : `Pickup_photo_${res?.data?.filename}`;

        setFile(filename);
        setLocalPhotos((prev) => ({
          ...prev,
          [obj.id]: filename,
        }));
        handleInputChange(obj?.id, '', obj, filename);
        toast?.success(
          `Photo ${upload ? 'uploaded' : 'captured'} successfully`
        );
        setCapturePhoto(false);
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      if (!error?.response && isMobile) {
        toast.error(
          'Please Use the upload option only for file uploads, and use a separate capture button to capture photos.'
        );
      } else if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error('Something went wrong while uploading');
      }
    } finally {
      setImageLoading(false); // stop loading in all cases
      setSelectedItem({});
    }
  };

  return (
    <Container
      maxWidth='sm'
      sx={{
        pt: 2,
        bgcolor: '#f9f9f9',
        p: '0 !important',
        borderRadius: 2,
        p: 2,
        minHeight: '100vh',
        maxHeight: 'fit-content',
      }}
    >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
      <Paper
        elevation={3}
        sx={{
          padding: '16px',
          minHeight: '100vh',
          maxHeight: 'fit-content',
        }}
      >
        <Box display='flex'>
          <FaCheckCircle
            size={22}
            fill='#0d970d'
            style={{ marginRight: '8px' }}
          />
          <div
            style={{
              display: 'flex',
              width: '100%',
              textDecoration: 'underline',
              fontSize: '1.1rem',
              fontWeight: 600,
            }}
          >
            OUTWARD PICK-UP
          </div>
        </Box>
        <Box component='form' sx={{ mt: 2 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 0.5,
              mb: 1,
            }}
          >
            <Typography
              variant='body2'
              sx={{ fontWeight: 700, fontSize: '1rem' }}
            >
              SELECT STATION
            </Typography>
            <Select
              name='department_id'
              value={selectedDepartment}
              fullWidth
              onChange={(e) => {
                setSelectedDepartment(e?.target?.value);
                setItemDeliveries([]);
                setAllocations([]);
                setSelectedItem({});
                setFile(null);
              }}
              variant='outlined'
            >
              {!isEmpty(departments) ? (
                map(departments, (option) => (
                  <MenuItem key={option?.id} value={option?.station}>
                    {option?.station}
                  </MenuItem>
                ))
              ) : (
                <MenuItem>No data found</MenuItem>
              )}
            </Select>
            {!selectedDepartment && (
              <Typography
                variant='caption'
                color='error'
                sx={{ fontSize: '0.7rem' }}
              >
                Station is required
              </Typography>
            )}
          </Box>

          {selectedDepartment && (
            <>
              {itemDeliveries.map((item, index) => {
                // const itemPhoto = find(allocations, {
                //   id: parseInt(item?.id),
                // })?.photo
                //   ? last(
                //       map(
                //         split(
                //           find(allocations, {
                //             id: parseInt(item?.id),
                //           })?.photo,
                //           ','
                //         ),
                //         trim
                //       )
                //     )
                //   : '';

                const itemPhoto =
                  localPhotos[item.id] ||
                  (find(allocations, { id: parseInt(item?.id) })?.photo
                    ? last(
                        map(
                          split(
                            find(allocations, { id: parseInt(item?.id) })
                              ?.photo,
                            ','
                          ),
                          trim
                        )
                      )
                    : '');

                const pickedupQty =
                  find(allocations, {
                    id: parseInt(item?.id),
                  })?.picked_qty ||
                  find(allocations, {
                    id: parseInt(item?.id),
                  })?.entered_qty;

                return (
                  <Box key={item.id} sx={{ mb: 1 }}>
                    {/* Item Name and Remaining Quantity */}
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        padding: '0.6rem',
                        borderBottom: '1px solid grey.300',
                        backgroundColor: '#f9f9f9', // Optional background color
                        position: 'relative',
                      }}
                    >
                      {/* Vertical Line for Card */}
                      <Box
                        sx={{
                          width: '4px',
                          height: '100%',
                          borderTopLeftRadius: '0.8rem',
                          borderBottomLeftRadius: '0.8rem',
                          backgroundColor: getLineColor(index), // Dynamic color based on itemType
                          position: 'absolute',
                          left: 0,
                          top: 0,
                        }}
                      />
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          width: '100%',
                          gap: 2,
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            '@media (max-width: 600px)': {
                              width: '40%', // Full width on mobile
                            },
                          }}
                        >
                          <Typography
                            variant='body1'
                            sx={{ fontWeight: 'bold', fontSize: '1rem' }}
                          >
                            {item?.item_name}
                          </Typography>
                          <Typography
                            variant='caption'
                            sx={{
                              mt: 0.5,
                              fontWeight: 'bold',
                              fontSize: '0.7rem',
                              whiteSpace: 'nowrap',
                              color: 'grey.600', // Grey color for remaining quantity
                            }}
                          >
                            DELIVERED: {item?.delivered_qty}
                          </Typography>
                          <Typography
                            variant='caption'
                            sx={{
                              mt: 0.5,
                              fontWeight: 'bold',
                              fontSize: '0.7rem',
                              whiteSpace: 'nowrap',
                              color: 'grey.600', // Grey color for remaining quantity
                            }}
                          >
                            PREV PICKED-UP: {item?.picked_qty}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-end',
                            gap: '0.5rem',
                            '@media (max-width: 600px)': {
                              width: '60%', // Full width on mobile
                            },
                          }}
                        >
                          <Typography
                            variant='caption'
                            sx={{
                              fontWeight: 520,
                              fontSize: '0.7rem',
                            }}
                          >
                            CURR PICKED-UP QTY
                          </Typography>
                          <TextField
                            id={`pick_up_${item.id}`}
                            type='number'
                            // disabled={item?.delivered_qty === item?.picked_qty}
                            onChange={(e) => {
                              // const newValue = sum([
                              //   item?.picked_qty,
                              //   Number(e.target.value),
                              // ]);

                              const newValue = Number(e.target.value);

                              handleInputChange(
                                item.id,
                                newValue,
                                item,
                                find(allocations, {
                                  id: parseInt(item?.id),
                                })?.photo
                              );
                              item.entered_qty = newValue;
                            }}
                            variant='outlined'
                            size='small'
                            fullWidth
                            sx={{
                              width: '80px',
                              '& .MuiOutlinedInput-root': {
                                // backgroundColor:
                                //   item?.delivered_qty === item?.picked_qty
                                //     ? '#f0f0f0'
                                //     : 'transparent',
                              },
                              '& .MuiInputBase-input': {
                                // cursor:
                                //   item?.delivered_qty === item?.picked_qty
                                //     ? 'not-allowed'
                                //     : 'auto',
                              },
                              '& .MuiOutlinedInput-root.Mui-disabled': {
                                backgroundColor: '#f0f0f0',
                              },
                              '& .MuiOutlinedInput-input': {
                                textAlign: 'right',
                              },
                            }}
                          />

                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              // gap: isMobile ? 1.5 : 0.5,
                              // pt: isMobile ? 0 : 3,
                              gap: 1,
                              width: '100%',
                              justifyContent: 'flex-end',
                            }}
                          >
                            {!capturePhoto && (
                              <IoCamera
                                onClick={() => {
                                  if (
                                    !pickedupQty ||
                                    pickedupQty === 0 ||
                                    pickedupQty < 0
                                  ) {
                                    toast.error('Please enter the qty first');
                                    return;
                                  } else {
                                    setCapturePhoto(true);
                                    setSelectedItem(item);
                                  }
                                }}
                                disabled={
                                  !selectedDepartment ||
                                  isEmpty(itemDeliveries) ||
                                  imageUploading
                                }
                                id={`capture-photo-${item.id}`}
                                fill='#2090ff'
                                cursor='pointer'
                                size={22}
                              />
                            )}
                            <>
                              <input
                                accept='image/*'
                                style={{ display: 'none' }}
                                id={`upload-file-${item.id}`} // unique per product/item
                                type='file'
                                onChange={(e) => {
                                  if (
                                    !pickedupQty ||
                                    pickedupQty === 0 ||
                                    pickedupQty < 0
                                  ) {
                                    toast.error('Please enter the qty first');
                                  } else {
                                    handleFileChange(
                                      e?.target?.files?.[0],
                                      true,
                                      item
                                    );
                                  }
                                }}
                              />

                              {/* Upload button */}
                              <CgSoftwareUpload
                                disabled={
                                  isEmpty(itemDeliveries) || imageUploading
                                }
                                color='red'
                                cursor='pointer'
                                size={24}
                                onClick={() => {
                                  if (
                                    !pickedupQty ||
                                    pickedupQty === 0 ||
                                    pickedupQty < 0
                                  ) {
                                    toast.error('Please enter the qty first');
                                  } else {
                                    document
                                      .getElementById(`upload-file-${item.id}`)
                                      ?.click();
                                  }
                                }}
                              />
                            </>
                            {itemPhoto && (
                              <Box>
                                <Typography
                                  variant='subtitle2'
                                  color='textSecondary'
                                  gutterBottom
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    fontSize: '0.9rem',
                                    ml: 1,
                                  }}
                                >
                                  <img
                                    src={`${process.env.REACT_APP_IMAGE_URL}/images/${itemPhoto}`}
                                    alt='Uploaded Preview'
                                    style={{
                                      width: '50px',
                                      height: '50px',
                                      marginTop: 8,
                                      borderRadius: '6px',
                                      cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                      setOpenModal(true);
                                      setSelectedImage(itemPhoto);
                                    }}
                                  />
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{ borderBottom: '1px solid #ddd' }} />
                  </Box>
                );
              })}
            </>
          )}

          {/* {file && (
            <Typography
              variant='subtitle2'
              color='textSecondary'
              gutterBottom
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                fontSize: '0.9rem',
                ml: 1,
              }}
            >
              <img
                src={`${process.env.REACT_APP_IMAGE_URL}/images/${file}`}
                alt='Uploaded Preview'
                style={{
                  width: '50px',
                  height: '50px',
                  marginTop: 8,
                  borderRadius: '6px',
                }}
                onClick={() => {
                  setOpenModal(true);
                  setSelectedImage(file);
                }}
              />
            </Typography>
          )} */}

          {/* {capturePhoto &&
            (imageUploading ? (
              <CircularProgress size={22} />
            ) : (
              <>
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat='image/jpeg'
                  videoConstraints={{ facingMode }}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />

                <Box
                  sx={{
                    display: 'flex',
                    gap: 1,
                    mt: 2,
                  }}
                >
                  <Button
                    variant='contained'
                    sx={{
                      textTransform: 'none',
                      p: '0 10px',
                      fontSize: '1rem',
                    }}
                    onClick={handleCapturePhoto}
                  >
                    CAPTURE
                  </Button>
                  <Button
                    variant='contained'
                    sx={{
                      textTransform: 'none',
                      p: '0 10px',
                      fontSize: '1rem',
                    }}
                    onClick={() => {
                      setCapturePhoto(false);
                    }}
                  >
                    CANCEL
                  </Button>
                  <MdFlipCameraIos
                    style={{ marginRight: '5px', cursor: 'pointer' }}
                    fill='#1876D1'
                    onClick={toggleCamera}
                    size={25}
                  />
                </Box>
              </>
            ))} */}

          <Box display='flex' justifyContent='space-between' sx={{ mt: 3 }}>
            {/* <Box display='flex' gap={1}>
              {selectedDepartment && !capturePhoto && (
                <Button
                  variant='contained'
                  color='error'
                  sx={{
                    textTransform: 'none',
                    p: '2px 10px',
                    fontSize: '1rem',
                  }}
                  onClick={() => setCapturePhoto(true)}
                  disabled={isEmpty(itemDeliveries) || imageUploading}
                >
                  TAKE PHOTO
                </Button>
              )}
              {selectedDepartment && (
                <>
                  <input
                    accept='image/*'
                    style={{ display: 'none' }}
                    id='upload-file'
                    type='file'
                    onChange={(e) =>
                      handleFileChange(e?.target?.files?.[0], true)
                    }
                  />
                  <Button
                    component='label'
                    htmlFor='upload-file'
                    variant='contained'
                    sx={{
                      textTransform: 'none',
                      p: '2px 10px',
                      fontSize: '1rem',
                    }}
                    disabled={isEmpty(itemDeliveries) || imageUploading}
                  >
                    <MdOutlineFileUpload size={18} /> UPLOAD
                  </Button>{' '}
                </>
              )}
            </Box> */}
            <Button
              variant='contained'
              color='primary'
              onClick={handleSubmit}
              disabled={
                !selectedDepartment ||
                isEmpty(itemDeliveries) ||
                imageUploading ||
                loading ||
                isEmpty(allocations)
              }
            >
              SUBMIT
            </Button>
          </Box>
        </Box>
      </Paper>

      {capturePhoto && (
        <WebcamPopup
          capturePhoto={capturePhoto}
          setCapturePhoto={setCapturePhoto}
          imageUploading={imageUploading}
          facingMode={facingMode}
          setFacingMode={setFacingMode}
          handleCapturePhoto={handleCapturePhoto}
          webcamRef={webcamRef}
        />
      )}

      {openModal && (
        <ImageModal
          open={openModal}
          handleClose={handleCloseModal}
          imageUrl={selectedImage}
        />
      )}
    </Container>
  );
};

export default PWAPickupForm;
